import React, { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";

const AdminEditProduct = () => {
  const { productId } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  // ÜRÜNÜ YÜKLE
  useEffect(() => {
    const fetchProduct = async () => {
      const ref = doc(db, "products", productId);
      const snap = await getDoc(ref);

      if (snap.exists()) setProduct(snap.data());
      setLoading(false);
    };

    fetchProduct();
  }, [productId]);

  const handleSave = async () => {
    await updateDoc(doc(db, "products", productId), {
      name: product.name,
      price: Number(product.price),
      desc: product.desc,
      form: product.form,
      category: product.category,
    });

    alert("✔ Ürün güncellendi!");
    navigate("/admin/products");
  };

  if (loading) return <p>Yükleniyor...</p>;
  if (!product) return <p>Ürün bulunamadı.</p>;

  return (
    <div className="p-10 max-w-xl mx-auto bg-white shadow rounded-xl">
      <h1 className="text-2xl font-bold mb-6">Ürün Düzenle</h1>

      <input
        className="w-full p-3 border rounded mb-3"
        value={product.name}
        onChange={(e) => setProduct({ ...product, name: e.target.value })}
      />

      <input
        type="number"
        className="w-full p-3 border rounded mb-3"
        value={product.price}
        onChange={(e) => setProduct({ ...product, price: e.target.value })}
      />

      <textarea
        className="w-full p-3 border rounded mb-3"
        value={product.desc}
        onChange={(e) => setProduct({ ...product, desc: e.target.value })}
      />

      <select
        className="w-full p-3 border rounded mb-3"
        value={product.form}
        onChange={(e) => setProduct({ ...product, form: e.target.value })}
      >
        <option>Tablet</option>
        <option>Kapsül</option>
        <option>Sıvı</option>
        <option>Çiğneme Tablet</option>
      </select>

      <button
        onClick={handleSave}
        className="w-full bg-green-600 text-white py-3 rounded font-bold"
      >
        Kaydet
      </button>
    </div>
  );
};

export default AdminEditProduct;
